import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

// Country pages
export const CountryListPage = lazy(
  () =>
    retry(() => import('@/pages/setting/countries/list')) as Promise<
      typeof import('@/pages/setting/countries/list')
    >
);

export const CountryEditPage = lazy(
  () =>
    retry(() => import('@/pages/setting/countries/edit')) as Promise<
      typeof import('@/pages/setting/countries/edit')
    >
);

export const CountryCreatePage = lazy(
  () =>
    retry(() => import('@/pages/setting/countries/create')) as Promise<
      typeof import('@/pages/setting/countries/create')
    >
);

// Currency pages
export const CurrencyListPage = lazy(
  () =>
    retry(() => import('@/pages/setting/currencies/list')) as Promise<
      typeof import('@/pages/setting/currencies/list')
    >
);

export const CurrencyEditPage = lazy(
  () =>
    retry(() => import('@/pages/setting/currencies/edit')) as Promise<
      typeof import('@/pages/setting/currencies/edit')
    >
);

export const CurrencyCreatePage = lazy(
  () =>
    retry(() => import('@/pages/setting/currencies/create')) as Promise<
      typeof import('@/pages/setting/currencies/create')
    >
);
